module.exports = __webpack_public_path__ + "static/media/golf-ball.6b4b307f.svg";